export const getSortDirection = (sortStr: string | null): string | null => {
  if (!sortStr) {
    return null;
  }

  const lastIndex = sortStr.lastIndexOf('_');

  const direction = sortStr.slice(lastIndex + 1);

  if (['asc', 'desc'].includes(direction)) {
    const sortType = sortStr.slice(0, lastIndex);

    return `${sortType}.${direction}`;
  }


  return `${sortStr}.asc`;
};
